const t = {}

t.loading = 'Loading...'

t.brand = {}
t.brand.lg = 'BASF Refinish Hub'
t.brand.mini = 'BASF'
t.brand.oem = 'OEM'
t.brand.carLine = 'Brand'
t.brand.carModel = 'Model'
t.brand.BASF_REFINISHHUB_MANAGEMENT_PORTAL = 'BASF REFINISH HUB MANAGEMENT PORTAL'

t.add = 'Add'
t.forgot_password = 'Forgot Password' 
t.Invitation_register = 'Invite to Register'
t.Invote_register = 'Invite to Register'
t.delete = 'Delete'
t.deleteBatch = 'Delete'
t.syncRecipe = 'Sync to App'
t.massiveUpload = 'Batch Upload'
t.update = 'Update'
t.query = 'Search'
t.export = 'Export'
t.handle = 'Operation'
t.confirm = 'Confirm'
t.finish = 'Finish'
t.cancel = 'Cancel'
t.clear = 'Clear'
t.logout = 'Logout'
t.manage = 'Manage'
t.createDate = 'CreateDate'
t.keyword = 'Keyword:'
t.choose = 'Choose'
t.view = 'View'

t.prompt = {}
t.prompt.title = 'Info'
t.prompt.info = 'Confirm operation to [{handle}]?'
t.prompt.success = 'Success!'
t.prompt.success1 = 'Success!'
t.prompt.failed = 'Failed!'
t.prompt.deleteBatch = 'Please select an item to delete'
t.prompt.sycBatch = 'Please select recipes to sync to the App'


t.validate = {}
t.validate.required = 'Cannot be blank'
t.validate.scanCodeRequired = "At least one of the rule time, brand, product line, or SKU must be filled in for item {index}"
t.validate.extraPointRequired = "Extra points are empty for item {index}"
t.validate.format = '{attr} format error'

t.validate.colorRgb = 'Please enter 6 letters/numbers'

t.upload = {}
t.upload.text = 'Drag files here, or <em>click to upload</em>'
t.upload.clickText = 'click to upload'
t.upload.tip = 'Only supports {format} format files!'
t.upload.button = 'Click to upload'

t.datePicker = {}
t.datePicker.range = 'to'
t.datePicker.start = 'startDate'
t.datePicker.end = 'endDate'

t.fullscreen = {}
t.fullscreen.prompt = 'Your browser does not support this operation'

t.updatePassword = {}
t.updatePassword.title = 'Change Password'
t.updatePassword.username = 'Account'
t.updatePassword.password = 'Original Password'
t.updatePassword.newPassword = 'New Password'
t.updatePassword.confirmPassword = 'Confirm Password'
t.updatePassword.validate = {}
t.updatePassword.validate.confirmPassword = 'The confirmation password is inconsistent with the password input'
t.updatePassword.validate.complexityPassword = 'password must compose letters and numbers with a length of 8-20 digits'

t.contentTabs = {}
t.contentTabs.closeCurrent = 'Close Current Tab'
t.contentTabs.closeOther = 'Close Other Tabs'
t.contentTabs.closeAll = 'Close All Tabs'

/* 页面 */
t.notFound = {}
t.notFound.desc = 'Sorry! The page you visited is <em>lost</em>...'
t.notFound.back = 'Back'
t.notFound.home = 'Home'

t.noAccess = {}
t.noAccess.desc = 'Sorry! You do not have <em>permission</em> to access this page/function...'
t.noAccess.back = 'Back'
t.noAccess.home = 'Home'

t.login = {}
t.login.lang = '中文/EN'
t.login.title = 'log in'
t.login.register = 'User registration'
t.login.username = 'UserName/E-mail'
t.login.password = 'Password'
t.login.captcha = 'Code'
t.login.send_code = 'Send Code',
t.login.demo = 'Online Demo'
t.login.please_select_data = 'Please select at least one list data'

t.schedule = {}
t.schedule.beanName = 'Bean Name'
t.schedule.beanNameTips = 'Spring Bean Name, e.g., testTask'
t.schedule.pauseBatch = 'Pause'
t.schedule.resumeBatch = 'Resume'
t.schedule.runBatch = 'Run'
t.schedule.log = 'Log List'
t.schedule.params = 'Parameters'
t.schedule.cronExpression = 'Cron Expression'
t.schedule.cronExpressionTips = 'e.g., 0 0 12 * * ?'
t.schedule.remark = 'Remark'
t.schedule.status = 'Status'
t.schedule.status0 = 'Paused'
t.schedule.status1 = 'Normal'
t.schedule.statusLog0 = 'Failed'
t.schedule.statusLog1 = 'Success'
t.schedule.pause = 'Pause'
t.schedule.resume = 'Resume'
t.schedule.run = 'Run'
t.schedule.jobId = 'Job ID'
t.schedule.times = 'Elapsed Time (ms)'
t.schedule.createDate = 'Execution Time'

t.oss = {}
t.oss.config = 'Cloud Storage Configuration'
t.oss.upload = 'Upload File'
t.oss.url = 'URL'
t.oss.createDate = 'Creation Date'
t.oss.type = 'Type'
t.oss.type1 = 'Qiniu'
t.oss.type2 = 'Aliyun'
t.oss.type3 = 'Tencent Cloud'
t.oss.qiniuDomain = 'Domain'
t.oss.qiniuDomainTips = 'Qiniu bound domain'
t.oss.qiniuPrefix = 'Path Prefix'
t.oss.qiniuPrefixTips = 'Default is empty if not set'
t.oss.qiniuAccessKey = 'AccessKey'
t.oss.qiniuAccessKeyTips = 'Qiniu AccessKey'
t.oss.qiniuSecretKey = 'SecretKey'
t.oss.qiniuSecretKeyTips = 'Qiniu SecretKey'
t.oss.qiniuBucketName = 'Bucket Name'
t.oss.qiniuBucketNameTips = 'Qiniu Bucket Name'
t.oss.aliyunDomain = 'Domain'
t.oss.aliyunDomainTips = 'Aliyun bound domain, e.g., http://cdn.renren.io'
t.oss.aliyunPrefix = 'Path Prefix'
t.oss.aliyunPrefixTips = 'Default is empty if not set'
t.oss.aliyunEndPoint = 'EndPoint'
t.oss.aliyunEndPointTips = 'Aliyun EndPoint'
t.oss.aliyunAccessKeyId = 'AccessKeyId'
t.oss.aliyunAccessKeyIdTips = 'Aliyun AccessKeyId'
t.oss.aliyunAccessKeySecret = 'AccessKeySecret'
t.oss.aliyunAccessKeySecretTips = 'Aliyun AccessKeySecret'
t.oss.aliyunBucketName = 'BucketName'
t.oss.aliyunBucketNameTips = 'Aliyun BucketName'
t.oss.qcloudDomain = 'Domain'
t.oss.qcloudDomainTips = 'Tencent Cloud bound domain'
t.oss.qcloudPrefix = 'Path Prefix'
t.oss.qcloudPrefixTips = 'Default is empty if not set'
t.oss.qcloudAppId = 'AppId'
t.oss.qcloudAppIdTips = 'Tencent Cloud AppId'
t.oss.qcloudSecretId = 'SecretId'
t.oss.qcloudSecretIdTips = 'Tencent Cloud SecretId'
t.oss.qcloudSecretKey = 'SecretKey'
t.oss.qcloudSecretKeyTips = 'Tencent Cloud SecretKey'
t.oss.qcloudBucketName = 'BucketName'
t.oss.qcloudBucketNameTips = 'Tencent Cloud BucketName'
t.oss.qcloudRegion = 'Region'
t.oss.qcloudRegionTips = 'Select'
t.oss.qcloudRegionBeijing1 = 'Beijing 1 (North China)'
t.oss.qcloudRegionBeijing = 'Beijing'
t.oss.qcloudRegionShanghai = 'Shanghai (East China)'
t.oss.qcloudRegionGuangzhou = 'Guangzhou (South China)'
t.oss.qcloudRegionChengdu = 'Chengdu (Southwest China)'
t.oss.qcloudRegionChongqing = 'Chongqing'
t.oss.qcloudRegionSingapore = 'Singapore'
t.oss.qcloudRegionHongkong = 'Hong Kong'
t.oss.qcloudRegionToronto = 'Toronto'
t.oss.qcloudRegionFrankfurt = 'Frankfurt'

t.dept = {}
t.dept.id = 'ID'
t.dept.name = 'Full Name'
t.dept.deptTypeName = 'DeptType'
t.dept.email = 'Email'
t.dept.paintLineName = 'PaintLine'
t.dept.parentName = 'ParentName'
t.dept.sort = 'Sort'
t.dept.parentNameDefault = 'ParentNameDefault'
t.dept.chooseerror = 'Select department'
t.dept.title = 'Select department'

t.dict = {}
t.dict.dictName = 'Dictionary Name'
t.dict.dictType = 'Dictionary Type'
t.dict.dictLabel = 'Dictionary Label'
t.dict.dictValue = 'Dictionary Value'
t.dict.sort = 'Sort'
t.dict.remark = 'Remark'
t.dict.createDate = 'Creation Date'

t.logError = {}
t.logError.requestUri = 'Request URI'
t.logError.requestMethod = 'Request Method'
t.logError.requestParams = 'Request Parameters'
t.logError.ip = 'IP Address'
t.logError.userAgent = 'User Agent'
t.logError.createDate = 'Creation Date'
t.logError.errorInfo = 'Error Information'

t.logLogin = {}
t.logLogin.creatorName = 'Username'
t.logLogin.status = 'Status'
t.logLogin.status0 = 'Failed'
t.logLogin.status1 = 'Success'
t.logLogin.status2 = 'Account Locked'
t.logLogin.operation = 'Operation Type'
t.logLogin.operation0 = 'Login'
t.logLogin.operation1 = 'Logout'
t.logLogin.ip = 'IP Address'
t.logLogin.userAgent = 'User-Agent'
t.logLogin.createDate = 'Creation Date'

t.logOperation = {}
t.logOperation.status = 'Status'
t.logOperation.status0 = 'Failed'
t.logOperation.status1 = 'Success'
t.logOperation.creatorName = 'Username'
t.logOperation.operation = 'User Operation'
t.logOperation.requestUri = 'Request URI'
t.logOperation.requestMethod = 'Request Method'
t.logOperation.requestParams = 'Request Parameters'
t.logOperation.requestTime = 'Request Duration'
t.logOperation.ip = 'IP Address'
t.logOperation.userAgent = 'User-Agent'
t.logOperation.createDate = 'Creation Date'

t.menu = {}
t.menu.name = 'Name'
t.menu.icon = 'Icon'
t.menu.type = 'Type'
t.menu.type0 = 'Menu'
t.menu.type1 = 'Button'
t.menu.sort = 'Sort'
t.menu.url = 'Route'
t.menu.permissions = 'Permission'
t.menu.permissionsTips = 'Multiple permissions separated by commas, e.g., sys:menu:save,sys:menu:update'
t.menu.parentName = 'Parent Menu'
t.menu.parentNameDefault = 'Top Level Menu'
t.menu.resource = 'Authorized Resource'
t.menu.resourceUrl = 'Resource URL'
t.menu.resourceMethod = 'Request Method'
t.menu.resourceAddItem = 'Add Item'

t.params = {}
t.params.paramCode = 'Code'
t.params.paramValue = 'Value'
t.params.remark = 'Remark'

t.role = {}
t.role.name = 'Name'
t.role.remark = 'Remark'
t.role.createDate = 'Creation Date'
t.role.menuList = 'Menu List'
t.role.deptLits = 'Data List'
t.role.type = 'Role Type'

t.user = {}
t.user.username = 'User Name'
t.user.role = 'Role'
t.user.deptName = 'Company'
t.user.email = 'Email'
t.user.mobile = 'Mobile'
t.user.status = 'Status'
t.user.status0 = 'Disable'
t.user.status1 = 'Enable'
t.user.createDate = 'CreateDate'
t.user.password = 'Password'
t.user.confirmPassword = 'Confirm Password'
t.user.realName = 'Real Name'
t.user.gender = 'Gender'
t.user.gender0 = 'Male'
t.user.gender1 = 'Female'
t.user.gender2 = 'Secrecy'
t.user.roleIdList = 'Role'
t.user.validate = {}
t.user.validate.confirmPassword = 'The confirmation password is inconsistent with the password input'
t.user.select = 'Select user'
t.user.selecterror = 'Please select a record'
t.user.adduser = 'Add user'
t.user.id_sub_dealer = 'Dealer'
t.user.body_shop = 'Bodyshop'
t.user.sendangin = 'Send again'

t.user.commentStatus = 'Comment Status'
t.user.allow = 'Allow'
t.user.forbid = 'Forbid'
t.user.forbiddenUntil = 'Forbidden Until'
t.user.selectDate = 'Select date'
t.user.forbidReason = 'Forbid Reason'
t.user.forbidReasonPlaceholder = 'Enter reason for forbidding (optional)'
t.user.errorForbidDate = 'Please select the expiration date for the ban'

t.ingredient = {}
t.ingredient.status0 = 'Inactive'
t.ingredient.status1 = 'Active'
t.ingredient.status2 = 'Enable'

t.model = {}
t.model.status0 = 'All'
t.model.status1 = 'App only'
t.model.status2 = 'English only'
t.model.status3 = 'Error'

t.source = {}
t.source.status0 = 'Batch upload'
t.source.status1 = 'Manual addition'
t.source.status2 = 'Approval addition'
t.source.status3 = 'Error'
t.source.status10 = 'UNICORN'

t.invalid = {}
t.invalid.status0 = 'Batch upload'
t.invalid.status1 = 'Manual addition'
t.invalid.status2 = 'Approval addition'

t.statusVModel = {}
t.statusVModel.statusVModel0 = 'Batch upload'
t.statusVModel.statusVModel1 = 'Manual addition'
t.statusVModel.statusVModel2 = 'Approval addition'
t.statusVModel.statusVModel3 = 'Error'

t.solid = {}
t.solid.status0 = '1K'
t.solid.status1 = '2K'
t.solid.status2 = 'Missing'
t.solid.status3 = 'Error'

t.colorSpecial = {}
t.colorSpecial.status0 = 'Metallic/Pearl'
t.colorSpecial.status1 = 'Metallic'
t.colorSpecial.status2 = 'Pearl'
t.colorSpecial.status3 = 'Solid'
t.colorSpecial.status4 = 'Other'
t.colorSpecial.status5 = 'Missing'
t.colorSpecial.status6 = 'Error'

t.recipeType = {}
t.recipeType.status0 = 'Official'
t.recipeType.status1 = 'Service provider'
t.recipeType.status2 = 'Personal'
t.recipeType.status3 = 'Missing'
t.recipeType.status4 = 'Error'

t.recipeSource = {}
t.recipeSource.status0 = 'Web'
t.recipeSource.status1 = 'App'
t.recipeSource.status2 = 'Missing'
t.recipeSource.status3 = 'Error'
t.recipeSource.status4 = 'Valid'
t.recipeSource.status5 = 'Invalid'
t.recipeSource.status6 = 'Recovered'
t.recipeSource.unicorn = 'Unicorn'

t.recipeInfo = {}
t.recipeInfo.upload = 'Batch upload'
t.recipeInfo.result = 'Upload result'
t.recipeInfo.submit = 'Submit'

t.auditCustomized = {}
t.auditCustomized.title = 'Customized recipe audit'
t.auditCustomized.detail = 'Customized recipe detail'
t.auditCustomized.audit = 'Audit'
t.auditCustomized.view = 'View'
t.auditCustomized.massiveAudit = 'Batch audit'
t.auditCustomized.reject = 'Reject'
t.auditCustomized.requestType0 = 'Model'
t.auditCustomized.requestType1 = 'Brand-Model'
t.auditCustomized.requestType2 = 'Color code'
t.auditCustomized.requestType3 = 'Color code-Model'
t.auditCustomized.requestType4 = 'Color code-Brand-Model'
t.auditCustomized.requestType5 = 'Error'
t.auditCustomized.paintBrand = 'Paint brand'
t.auditCustomized.oem = 'OEM'
t.auditCustomized.carBrand = 'Car brand'
t.auditCustomized.carModel = 'Car model'
t.auditCustomized.colorCode = 'Color code'
t.auditCustomized.colorName = 'Color name'
t.auditCustomized.auditStatus = 'Audit status'
t.auditCustomized.auditStatus0 = 'Pending'
t.auditCustomized.auditStatus1 = 'Approved'
t.auditCustomized.auditStatus2 = 'Rejected'
t.auditCustomized.auditStatus3 = 'Approved (Similar)'
t.auditCustomized.officialOem = 'Official OEM'
t.auditCustomized.officialCarBrand = 'Official car brand'
t.auditCustomized.officialCarModel = 'Official car model'
t.auditCustomized.customizedOem = 'Customized OEM'
t.auditCustomized.customizedCarBrand = 'Customized car brand'
t.auditCustomized.customizedCarModel = 'Customized car model'
t.auditCustomized.createUser = 'Create user'
t.auditCustomized.createDate = 'Create date'
t.auditCustomized.basicInfo = 'Basic information'
t.auditCustomized.carMatrixInfo = 'Car matrix information'
t.auditCustomized.recipeInfo = 'Recipe information'
t.auditCustomized.requestType = 'Audit type'
t.auditCustomized.recipeType = 'Recipe type'
t.auditCustomized.recipeType1 = 'Official'
t.auditCustomized.recipeType2 = 'Service provider'
t.auditCustomized.recipeType3 = 'Personal'
t.auditCustomized.recipeSource = 'Recipe source'
t.auditCustomized.recipeSource1 = 'Web'
t.auditCustomized.recipeSource2 = 'App'
t.auditCustomized.recipeSource3 = 'Unicorn'
t.auditCustomized.recipeYear = 'Recipe year'
t.auditCustomized.firstYear = 'Effective year'
t.auditCustomized.lastYear = 'Invalid year'
t.auditCustomized.recipeStatus = 'Recipe status'
t.auditCustomized.recipeStatus1 = 'Valid'
t.auditCustomized.recipeStatus0 = 'Invalid'
t.auditCustomized.carAge = 'Car age'
t.auditCustomized.carAge0 = 'General'
t.auditCustomized.carAge1 = 'Within 1 year'
t.auditCustomized.carAge2 = '1-3 years'
t.auditCustomized.carAge3 = 'More than 3 years'
t.auditCustomized.colorID = 'Color ID'
t.auditCustomized.colorGroup = 'Color group'
t.auditCustomized.colorNameCn = 'Color name (CN)'
t.auditCustomized.colorNameEn = 'Color name (EN)'
t.auditCustomized.colorEffect = 'Color effect'
t.auditCustomized.colorEffect1 = 'Metallic/Pearl'
t.auditCustomized.colorEffect2 = 'Pearl'
t.auditCustomized.colorEffect3 = 'Metallic'
t.auditCustomized.colorEffect4 = 'Solid'
t.auditCustomized.rgb = 'RGB'
t.auditCustomized.rgbPlaceholder = 'rgb_45'
t.auditCustomized.voc = 'VOC'
t.auditCustomized.multiStorey = 'Multi-storey'
t.auditCustomized.multiStorey0 = 'False'
t.auditCustomized.multiStorey1 = 'True'
t.auditCustomized.recipeProcess = 'Recipe process'
t.auditCustomized.recipeProcess1 = 'Step 1'
t.auditCustomized.recipeProcess2 = 'Step 2'
t.auditCustomized.recipeProcess3 = 'Step 3'
t.auditCustomized.tinter = 'Tinter'
t.auditCustomized.weight = 'Weight'
t.auditCustomized.businessCode = 'Business code'
t.auditCustomized.recipeRemark = 'Recipe remark'
t.auditCustomized.auditResult = 'Audit result'
t.auditCustomized.auditResult1 = 'Approve'
t.auditCustomized.auditResult2 = 'Reject'
t.auditCustomized.oemType = 'OEM type'
t.auditCustomized.carBrandType = 'Car Brand type'
t.auditCustomized.carModelType = 'Car Model type'
t.auditCustomized.colorCodeType = 'Color code type'
t.auditCustomized.existedOem = 'Existed OEM'
t.auditCustomized.newAddedOem = 'New added OEM'
t.auditCustomized.existedCarBrand = 'Existed car brand'
t.auditCustomized.newAddedCarBrand = 'New added car brand'
t.auditCustomized.existedCarModel = 'Existed car model'
t.auditCustomized.newAddedCarModel = 'New added car model'
t.auditCustomized.existedColorCode = 'Existed color code'
t.auditCustomized.newAddedColorCode = 'New added color code'
t.auditCustomized.oemCn = 'OEM (CN)'
t.auditCustomized.oemEn = 'OEM (EN)'
t.auditCustomized.carBrandCn = 'Car brand (CN)'
t.auditCustomized.carBrandEn = 'Car brand (EN)'
t.auditCustomized.carModelCn = 'Car model (CN)'
t.auditCustomized.carModelEn = 'Car model (EN)'
t.auditCustomized.auditComments = 'Audit comments'






t.commercialTenant = {}
t.commercialTenant.name = 'Name'
t.commercialTenant.receive_applyfor = 'My received'
t.commercialTenant.receive_send = 'My applied for'
t.commercialTenant.to_be_confirmed = 'To be processed'
t.commercialTenant.confirmed = 'Agreed'
t.commercialTenant.closed_rejected = 'Rejected'
t.commercialTenant.data1 = 'Applicant'
t.commercialTenant.data2 = 'Type of dealer'
t.commercialTenant.dataName = 'Applicant'
t.commercialTenant.dataCode = 'Type of dealer'
t.commercialTenant.data3 = 'Type of application'
t.commercialTenant.data4 = 'Time of application'
t.commercialTenant.data5 = 'Status'
t.commercialTenant.data6 = 'Agree'
t.commercialTenant.data7 = 'Refuse'
t.commercialTenant.data8 = 'Withdraw'
t.commercialTenant.data9 = 'To be processed'
t.commercialTenant.data10 = 'Agreed'
t.commercialTenant.data11 = 'Rejected'
t.commercialTenant.data12 = 'Relationship Changing'
t.commercialTenant.data13 = 'Add an existing dealer'
t.commercialTenant.data14 = 'Dealer Code'
t.commercialTenant.data15 = 'Active'
t.commercialTenant.data16 = 'Inactive'

t.commercialTenant.abbreviation = 'Short Name'
t.commercialTenant.Belong_to = 'Belong to'
t.commercialTenant.dealer = 'Upper Dealer'
t.commercialTenant.dealer1 = 'Upper Dealer'
t.commercialTenant.updateDealer = 'Change the higher level dealer'
t.commercialTenant.mso = 'Upper MSO'
t.commercialTenant.mso1 = 'Upper MSO'
t.commercialTenant.region = 'Country/Region'
t.commercialTenant.regionCountry = 'Country'
t.commercialTenant.regionTenant = 'Address'
t.commercialTenant.mail = 'E-mail'
t.commercialTenant.administratorMail = 'Manager E-mail'
t.commercialTenant.administratorPhone = 'Manager Mobile Number'
t.commercialTenant.phone = 'Mobile'
t.commercialTenant.paintLineName = 'PaintLine'
t.commercialTenant.select = 'Select'
t.commercialTenant.selectOne = 'At least one entry is required'
t.commercialTenant.RepresentativeBASF = 'BASF Sales Rep.'
t.commercialTenant.RepresentativeBASF1 = 'BASF Sales Rep.'
t.commercialTenant.state0 = 'Inactive'
t.commercialTenant.state1 = 'Active'
t.commercialTenant.notAvailable = 'Missing'
t.commercialTenant.sendVerificationCode = 'Send verification code'
t.commercialTenant.back = 'Back'
t.commercialTenant.passwordAssistance = 'Password Reset' 
t.commercialTenant.Mailboxformaterror = 'Formal error'

t.commercialTenant.country_data1 = 'China'
t.commercialTenant.country_data2 = 'India'
t.commercialTenant.country_data3 = 'Indonesia'
t.commercialTenant.country_data4 = 'Malaysia'
t.commercialTenant.country_data5 = 'Thailand'
t.commercialTenant.country_data6 = 'Vietnam'
t.commercialTenant.country_data7 = 'Philippines'

t.layout_data = {}
t.layout_data.title = 'Title'
t.layout_data.scope = 'Scope'
t.layout_data.state = 'Status'
t.layout_data.content = 'Content'
t.layout_data.home = 'Show on Home'
t.layout_data.assing = 'Pin to Top'
t.layout_data.createdtime = 'Create Time'
t.layout_data.time = 'Publish Time'
t.layout_data.noticeTime = 'Notice Time'
t.layout_data.sendNotice = 'Send Notice'
t.layout_data.createdperson = 'Creator'
t.layout_data.query = 'Search'
t.layout_data.add = 'Add'
t.layout_data.delete = 'Delete'
t.layout_data.operate = 'Operate'
t.layout_data.revamp = 'Update'
t.layout_data.issue = 'Publish'
t.layout_data.china = 'China'
t.layout_data.foreign_country = 'APAC'
t.layout_data.upload = 'Upload Image'
t.layout_data.image_hint = 'Suggested size: 1080x600'
t.layout_data.name="user Name"
t.layout_data.commercialTtenant = 'Company';
t.layout_data.yes = 'Yes'
t.layout_data.no = 'No'
t.layout_data.region = 'Contry'
t.layout_data.date = 'Feedback Date'
t.layout_data.type = 'Type'
t.layout_data.dateIssue = 'Feedback Time'
t.layout_data.describe = 'Description'
t.layout_data.response = 'Response'
t.layout_data.img = 'Image'
t.layout_data.resolved = 'Resolved'
t.layout_data.unsolved = 'Unsolved'
t.layout_data.state1 = 'Status'
t.layout_data.reply = 'Reply'
t.layout_data.centent = 'Content'
t.layout_data.feedbacktype1 = 'Request to delete recipe'
t.layout_data.feedbacktype2 = 'Recipe info error'
t.layout_data.feedbacktype3 = 'Inappropriate comment'
t.layout_data.feedbacktype4 = 'Points related'
t.layout_data.feedbacktype5 = 'App issues & suggestions'
t.layout_data.feedbacktype7 = 'QR code not recognized'
t.layout_data.feedbacktype8 = 'Failed to access the camera'
t.layout_data.feedbacktype9 = 'Failed to open the scanner'
t.layout_data.feedbacktype10 = 'Failed to earn scan points'
t.layout_data.feedbacktype6 = 'Other'
t.layout_data.id="Recipe ID"
t.layout_data.enable_country= 'Enable Country'
// 用户评论管理
t.layout_data.comment_date = 'Comment Date'
t.layout_data.state2 = 'Comment Status'
t.layout_data.announcement = 'Top Announcement'


// 轮播图管理
t.banner = {}
t.banner.title = 'Banner {number}'

// 学习资料管理form表单
t.learning_materials = {}
t.learning_materials.name = 'Material Name'
t.learning_materials.range = 'Material Scope'
t.learning_materials.directory = 'Primary Directory'
t.learning_materials.paint_brand = 'Paint Brand'
t.learning_materials.status = 'Material Status'
t.learning_materials.query = 'Search'
t.learning_materials.add = 'Add'
t.learning_materials.delete = 'Delete'

t.learning_materials.china = 'China'
t.learning_materials.foreign_country = 'Asia Pacific'
t.learning_materials.knowledge = 'Technical Information'
t.learning_materials.technique = 'Construction Video'
t.learning_materials.technology = 'Coating Knowledge'
t.learning_materials.released = 'To be released'
t.learning_materials.published = 'Published'
t.learning_materials.withdrawn = 'Withdrawn'

t.learning_materials.img = 'Display Picture'
t.learning_materials.pdf = 'PDF Resource'
t.learning_materials.material_name = 'Material Name'
t.learning_materials.material_introduce = 'Material Introduction'
t.learning_materials.material_range = 'Material Scope'
t.learning_materials.material_brand = 'Paint Brand'
t.learning_materials.material_directory = 'Primary Directory'
t.learning_materials.material_status = 'Status'
t.learning_materials.material_release_time = 'Release Time'
t.learning_materials.material_create_time = 'Create Time'
t.learning_materials.material_create = 'Creator'
t.learning_materials.operate = 'Operation'
t.learning_materials.revamp = 'Update'
t.learning_materials.release = 'Publish'
t.learning_materials.withdraw = 'Withdraw'
t.learning_materials.paint_brand1 = 'Norbin'
t.learning_materials.paint_brand2 = 'Glazurit'
t.learning_materials.video_link = 'Video Link'
t.learning_materials.delete_image = 'Please delete the image before re-uploading'

t.gift = {}
t.gift.upload = 'Upload'
t.gift.uploadPicture = 'Picture upload'
t.gift.status0 = 'Disabled'
t.gift.status1 = 'Enabled'
t.gift.operationFailed = 'Operation failed'
t.gift.giftName = 'Gift name'
t.gift.giftDescription = 'Gift description'
t.gift.giftImgUrl = 'Picture URL'
t.gift.giftCost = 'Gift cost'
t.gift.giftInventory = 'Current inventory'
t.gift.giftOriginalInventory = 'Starting inventory'
t.gift.giftId = 'Gift ID'
t.gift.giftStatus = 'Status'

t.redemption = {}
t.redemption.status0 = 'Activated'
t.redemption.status1 = 'Deactivated'
t.redemption.save = 'Save'
t.redemption.startDateInvalid = 'Start date is invalid'
t.redemption.endDateInvalid = 'End date is invalid'
t.redemption.startDateMustBeBeforeEndDate = 'Start date must be earlier than end date'
t.redemption.startDateMustBeAfterToday = 'Start date must be later than today'
t.redemption.endDateMustBeAfterToday = 'End date must be later than today'
t.redemption.giftSelectionPromptRequired = 'Gift selection prompt is required'
t.redemption.submissionPromptRequired = 'Submission prompt is required'
t.redemption.allFieldsRequired = 'Please provide values for all required fields'
t.redemption.dataNotSaved = 'Data not saved!'
t.redemption.currentStatus = 'Current status'
t.redemption.saveToViewPicture = 'Picture will be updated after saving...'
t.redemption.period = 'Redemption period'
t.redemption.banner = 'Banner'
t.redemption.pictureUrl = 'Picture URL'
t.redemption.giftSelectionPrompt = 'After gift selection prompt'
t.redemption.submissionPrompt = 'After submission prompt'
t.redemption.status = 'Status'
t.redemption.displayedApp  = 'Displayed in App'

t.activitysetting = {}
t.activitysetting.startDateMustBeAfterToday='Start date must be after today'
t.activitysetting.startDateMustBeBeforeEndDate='Start date must be before end date'

t.orders = {}
t.orders.orderId = 'Order ID'
t.orders.status0 = 'To be delivered'
t.orders.status1 = 'Delivered'
t.orders.status2 = 'Cancelled by user'
t.orders.status3 = 'Cancelled by admin'
t.orders.ship = 'Ship'
t.orders.revert = 'Revert' // not in used at the moment
t.orders.cancel = 'Cancel'
t.orders.cancelReason = 'Reason for cancellation'
t.orders.reason = 'Reason'
t.orders.isShippedOrCancelled = 'Order has been shipped or cancelled'
t.orders.confirmShip = 'Ship order for ID'
t.orders.confirmShipping = 'Shipping confirmation'
t.orders.contact = 'Contact'
t.orders.userName = 'User name'
t.orders.giftId = 'Gift ID'
t.orders.giftName = 'Gift name'
t.orders.redeemDate = 'Redeem date'
t.orders.receiverName = 'Receiver'
t.orders.shippingAddress = 'Address'
t.orders.giftCost = 'Gift cost'
t.orders.orderStatus = 'Order status'
t.orders.cancelReason = 'Cancel reason'
t.orders.amount = 'Amount'

t.point = {}
t.point.point = "point"
t.point.distributorUserPointAccrual = "Distributor user point accrual"

t.point.adjustPoints = 'Adjust points'
t.point.userName = 'User name'
t.point.merchantName = 'Merchant name'
t.point.provinceName = 'Province'
t.point.userMobileNumber = 'Mobile'
t.point.userRealName = 'User real name'
t.point.roleName = 'Role'
t.point.pointBalance = 'Point balance'
t.point.remarks = 'Remarks'
t.point.exampleInput = 'e.g. 10, -100, 250, -50'

t.general = {}
t.general.uploadFailed = 'Upload failed'
t.general.noPicture = 'No picture'
t.general.statusInvalid = 'Invalid status'
t.general.noData = 'No data'
t.general.invalidUserId = 'Invalid user id'
t.general.uploadingPicture = 'Uploading picture...'
t.general.startDate = 'Start date'
t.general.endDate = 'End date'
t.general.to = 'to'

t.userAudit = {}
t.userAudit.username = 'userName'
t.userAudit.realName = 'realName'
t.userAudit.mobile = 'mobile'
t.userAudit.status = 'status'
t.userAudit.status0 = 'pending'
t.userAudit.status1 = 'approved'
t.userAudit.status2 = 'rejected'
t.userAudit.regiestDate='registrationDate'
t.userAudit.comTypeName='companyType'
t.userAudit.comName='companyName'
t.userAudit.province='identity'
t.userAudit.addr='address'
t.userAudit.provider='productProvider'
t.userAudit.audit='audit'
t.userAudit.auditResult='auditResult'
t.userAudit.auditTitle='userAudit'

t.recipeCollection = {}
t.recipeCollection.defaultSetting = 'Default Settings'
t.recipeCollection.paintBrand = 'Paint Brand'
t.recipeCollection.oem = 'OEM'
t.recipeCollection.carBrand = 'Car Brand'
t.recipeCollection.carModel = 'Car Model'
t.recipeCollection.colorCode = 'Color Code'
t.recipeCollection.colorName = 'Color Name'
t.recipeCollection.collectStatus = 'Collect Status'
t.recipeCollection.collectStatus0 = 'Draft'
t.recipeCollection.collectStatus1 = 'Published'
t.recipeCollection.collectStatus2 = 'Completed'
t.recipeCollection.collectStatus3 = 'Manual Removed'
t.recipeCollection.collectionProgress = 'Collection Progress'
t.recipeCollection.bonusPoint = 'Bonus Points'
t.recipeCollection.publishTime = 'Publish Time'
t.recipeCollection.edit = 'Edit'
t.recipeCollection.publish = 'Publish'
t.recipeCollection.delete = 'Delete'
t.recipeCollection.manualRemove = 'Manual Remove'
t.recipeCollection.view = 'View'
t.recipeCollection.collectNum = 'Collect Number'
t.recipeCollection.needVerify = 'Manual Verify'
t.recipeCollection.topCollection = 'Urgent Collection'
t.recipeCollection.audit = 'Audit'
t.recipeCollection.auditStatus = 'Audit Status'
t.recipeCollection.auditStatus0 = 'Pending'
t.recipeCollection.auditStatus1 = 'Approved'
t.recipeCollection.auditStatus2 = 'Rejected'
t.recipeCollection.verifyStatus = 'Audit Result'
t.recipeCollection.verifyStatus1 = 'Approve'
t.recipeCollection.verifyStatus2 = 'Reject'
t.recipeCollection.verifyComment = 'Audit Comment'
t.recipeCollection.back = 'Back'
t.recipeCollection.input = 'Please input'
t.recipeCollection.uploadTime = 'Upload Time'
t.recipeCollection.uploadUser = 'Upload User'
t.recipeCollection.recipeId = 'Recipe ID'
t.recipeCollection.publishConfirm = 'Publish recipe collection'
t.recipeCollection.formulaType = 'Formula Type'
t.recipeCollection.customizedType0 = 'Not customized'
t.recipeCollection.customizedType1 = 'Customized car model: Pending'
t.recipeCollection.customizedType2 = 'Customized car model: Approved'
t.recipeCollection.customizedType3 = 'Customized car model: Rejected'
t.recipeCollection.customizedType4 = 'Customized car model: Approved (Similar)'





// 用户评论管理
t.user_comment = {}
t.user_comment.comment_time = 'commentTime'
t.user_comment.user_name = 'userName'
t.user_comment.merchant = 'merchant'
t.user_comment.region = 'country'
t.user_comment.score = 'score'
t.user_comment.content = 'content'
t.user_comment.imgs = 'imgs'
t.user_comment.formula = 'formula'
t.user_comment.status = 'status'
t.user_comment.effective = 'effective'
t.user_comment.invalid = 'invalid'
t.user_comment.shield = 'shield'
t.user_comment.restore = 'restore'

t.pointRule = {}
t.pointRule.pointRuleEnabledCountry = 'Enabled Country'
t.pointRule.pointRuleCountryTip = 'BASF internal users can not earn points.'
t.pointRule.pointRuleIntro = 'Point Rules Intro'
t.pointRule.pointRuleAccrualRelatedToFormulas = 'Points accrual related to formulas'
t.pointRule.pointRuleAccrualRelatedToScan = 'Points accrual related to Scan'
t.pointRule.pointRuleAccrualRelatedToTechnicalAssessment = 'Points accrual related to Technical assessment'

t.pointRule.pointRuleReferralBonusTitle = 'Referral bonus'
t.pointRule.pointRuleReferralBonusEarn ="Earn"
t.pointRule.pointRuleReferralBonusEarnEnd ="% of points earned by referred users from Uploading Formulas (incl. extra bonus of formula upload)."
t.pointRule.pointRuleReferralScanCode ="Earn"
t.pointRule.pointRuleReferralScanCodeEnd ="% of points earned by referred users (external only) from scan"

t.pointRule.pointRuleUploadingFormulasTitle ="Uploading Formulas"
t.pointRule.pointRuleUploadingFormulasTip = 'User can upload photo and earn extra points at a later time, but user can only earn this extra points per formula one time.'
t.pointRule.pointRuleUploadingFormulasWillEarn ="When you upload a formula, you will earn"
t.pointRule.pointRuleUploadingFormulasPoints ="points."
t.pointRule.pointRuleUploadingFormulasAdditionally="Additionally, if you upload it with a photo, you will earn extra"

t.pointRule.pointRuleInteractingTitle = "Interacting with others' formulas"
t.pointRule.pointRuleInteractingTip = 'The same user will not accrual points for rating,text commenting,and image commenting on the same formula multiple times.'
t.pointRule.pointRuleInteractingTip1 = 'User can nir rate or review own formulas.'
t.pointRule.pointRuleInteractingPointRatingOther = "Rating other's formula will earn"
t.pointRule.pointRuleInteractingPointRatingOtherCountPoint = "points each time , up to a maximum of"
t.pointRule.pointRuleInteractingPointRatingOtherDayPoint = "points per day, and up to a maximum of"
t.pointRule.pointRuleInteractingPointRatingOtherMonthPoint = "points per month. "
t.pointRule.pointRuleInteractingContentPointRatingOtherMonthPoint = "Review other's formula with text  will earn"
t.pointRule.pointRuleInteractingImgRatingOtherMonthPoint = "Review other's formula with photo will earn"

t.pointRule.pointRuleInteractingOthenUserTitle = "Others interacting with your formulas"
t.pointRule.pointRuleInteractingOthenUserTip = 'Same users user , bookmark , or rate multiple times will not acrual additional points.'
t.pointRule.pointRuleInteractingOthenUserTip1 = 'Formula being used means that others open and adjust your formula.'
t.pointRule.pointRuleInteractingOthenUserUseFormulas="Bonus for being Used: If your formula is used by others, you will earn"
t.pointRule.pointRuleInteractingOthenUserUseFormulasPoints = "points each time it is used, up to a maximum of"
t.pointRule.pointRuleInteractingOthenUserUseFormulasMaxPoints = "points for one formula."
t.pointRule.pointRuleInteractingOthenUserCollectFormulas="Bonus for being Bookmarked: If your formula is bookmarked by others, you will earn"
t.pointRule.pointRuleInteractingOthenUserCollectFormulasPoints = "points each time, up to a maximum of"
t.pointRule.pointRuleInteractingOthenUserCollectFormulasMaxPoints = "points for one formula."
t.pointRule.pointRuleInteractingOthenUserScoreMin="Bonus for having Good Rating: if your formula receives a rating higher than or equal to"
t.pointRule.pointRuleInteractingOthenUserScorePoints = ", you will earn"

t.pointRule.pointRuleTechnicalAssessmentTitle = "Technical assessment"
t.pointRule.pointRuleTechnicalAssessmenteExam = "After passing the exam, you will earn"

t.pointRule.pointRuleScanCodeTitle = "Scan QRcode"
t.pointRule.pointRuleScanCodeSuccess = "After successfully scanning and verifying the anti-counterfeiting QRcode, you will earn"

t.pointRule.pointRuleScanCodeExtraTitle = "Scan QRcode(Extra rule)"
t.pointRule.pointRuleScanCodeExtraRuleTime = "Rule time："
t.pointRule.pointRuleScanCodeExtraRuleBeginTime = "beginTime"
t.pointRule.pointRuleScanCodeExtraTo = "to"
t.pointRule.pointRuleScanCodeExtraRuleEndTime = "endTime"
t.pointRule.pointRuleScanCodeExtraPaintBrand = "Paint Brand："
t.pointRule.pointRuleScanCodeExtraPaintline = "Paintline："
t.pointRule.pointRuleScanCodeExtraSKU = "SKU："
t.pointRule.pointRuleScanCodeExtraPoints = "Extra points："

//消息推送
t.userMsg = {}
t.userMsg.title = 'Title'
t.userMsg.content = 'Content'
t.userMsg.target = 'Target'
t.userMsg.type = 'Type'
t.userMsg.status = 'Status'
t.userMsg.allUsers = 'All Users'
t.userMsg.specificUsers = 'Specific Users'
t.userMsg.userIdsPlaceholder = 'Please enter user IDs, separated by commas'
t.userMsg.userIdsFormatError = 'User ID format is incorrect, please use commas to separate'
t.userMsg.publishDate = 'Publish Date'
t.userMsg.createDate = 'Create Date'
t.userMsg.statusDraft = 'Draft'
t.userMsg.statusPublished = 'Published'
t.userMsg.pstartDate = "Publish Start Date"
t.userMsg.pendDate = "Publish End Date"
t.userMsg.cstartDate = "Create Start Date"
t.userMsg.cendDate = "Create End Date"
t.userMsg.publish = 'Publish'
t.userMsg.receiveUserIdsFormatError = 'Receive User ID format is incorrect, please use commas to separate'
t.userMsg.publishConfirm = 'Publish Confirmation'
t.userMsg.publishSuccess = 'Publish successful'
export default t
